import {QueryCommand} from "xmgoing-server";
import SysConfigUtils from "@/utils/sysConfigUtils";
import GoingUtils from "@/utils/goingUtils";
import {useGlobSetting} from "@/hooks/setting";
import {GoingNewUtils, StorageUtils} from 'xmgoing-utils';
import {RoleEnum} from "@/enums/roleEnum";

const PlatformPrefix = SysConfigUtils.go_eplat_adress;


/**
 * 初始化系统布局信息
 * @param configObj
 */
export function initLayout(configObj, systemConfig,isNewUser,position) {
  if(systemConfig.xmIntegrationFlag!=null){
    StorageUtils.addSessionItem('xmIntegrationFlag', GoingNewUtils.parseBoolean(systemConfig.xmIntegrationFlag));
  }
  StorageUtils.addSessionItem('isNewUser', GoingNewUtils.parseBoolean(isNewUser));
  if (systemConfig.moreLangFlag) {
    useGlobSetting({ moreLangFlag: systemConfig.moreLangFlag });
  }
  //如果是普通用户 并且开启来指引
  if(systemConfig&&GoingNewUtils.parseBoolean(systemConfig.startUserZhiYin)&&position==='user'){
    StorageUtils.addSessionItem('openUserZhiYin', "true");
    StorageUtils.removeSessionItem('openUnitAdminZhiYin');
  }else{
    StorageUtils.removeSessionItem('openUserZhiYin');
  }
  //如果是单位管理员 并且开启来指引
  if(systemConfig&&GoingNewUtils.parseBoolean(systemConfig.startUnitAdminZhiYin)&&position==='unitAdmin'){
    StorageUtils.addSessionItem('openUnitAdminZhiYin', "true");
    StorageUtils.removeSessionItem('openUserZhiYin');
  }else{
    StorageUtils.removeSessionItem('openUnitAdminZhiYin');
  }

  if (StorageUtils.getSessionItem('loginUserType') === RoleEnum.USER_UNIT_ROLE) {
    if (systemConfig && systemConfig.closeUnitSpaceSel) {
      StorageUtils.addSessionItem('closeUnitSpaceSel', systemConfig.closeUnitSpaceSel);
    } else {
      StorageUtils.removeSessionItem('closeUnitSpaceSel');
    }
    //单位管理员门户
    if (systemConfig && systemConfig.unitPortalUrl) {
      StorageUtils.addSessionItem('unitPortalUrl', systemConfig.unitPortalUrl);
    } else {
      StorageUtils.removeSessionItem('unitPortalUrl');
    }
  }

  if (StorageUtils.getSessionItem('loginUserType') === RoleEnum.USER_GROUP_ADMIN_ROLE) {
    if (systemConfig && systemConfig.closeGroupSpaceSel) {
      StorageUtils.addSessionItem('closeGroupSpaceSel', systemConfig.groropPortalUrl);
    } else {
      StorageUtils.removeSessionItem('closeGroupSpaceSel');
    }
  }

  if (StorageUtils.getSessionItem('loginUserType') === RoleEnum.USER_ROLE) {
    systemConfig && GoingNewUtils.parseBoolean(systemConfig.closeUserSpaceSel)
      ? StorageUtils.addSessionItem(
        'closeUserSpaceSel',
        GoingNewUtils.parseBoolean(systemConfig.closeUserSpaceSel),
      )
      : StorageUtils.removeSessionItem('closeUserSpaceSel');
    systemConfig && systemConfig.userPortalUrl
      ? StorageUtils.addSessionItem('userPortalUrl', systemConfig.userPortalUrl)
      : StorageUtils.removeSessionItem('userPortalUrl');
  }

  if (configObj && configObj.layoutId) {
    StorageUtils.addItem('layout', configObj.layoutId);
  }
  // 个性化设置保存的框架偏好优先，避免启动时被旧的 config.layoutId 覆盖
  const preferredLayout = StorageUtils.getSessionItem('xm_preferred_layout');
  if (preferredLayout) {
    StorageUtils.addItem('layout', preferredLayout);
    if (configObj) {
      configObj.layoutId = preferredLayout;
    }
  }
}


/**
 * 根据内部连接器获取数据
 * @param innerApiRecord
 * @param successFun
 */
export function getDatasByInnerApi(innerApiRecord: any, successFun: any,curPage=1) {
  let {url, params = {}, method} = innerApiRecord;
  try {
    params = JSON.parse(params)
  } catch (e) {
    params = {current:curPage};
  }
  const queryCommand = new QueryCommand({
    url: PlatformPrefix + `${url}`,
    showTip: false,
    method,
  });
  queryCommand.executeQuery({page: false, params, successFun})
}

/**
 * 根据集成服务获取数据
 * @param connectionApiRecord
 * @param successFun
 */
export function getDatasByConnectionApi({connectionApiRecord, successFun,curPage=1,pageSize=20}) {
  const {openApi, requestMethod} = connectionApiRecord;
  const params = {current:curPage,size:pageSize};
  const queryCommand = new QueryCommand({
    url: openApi,
    showTip: false,
    method:requestMethod[0],
  });
  queryCommand.executeQuery({page: false, params, successFun:(datas)=>{
    if(datas.data){
      successFun&&successFun(datas.data);
    }else{
      successFun&&successFun(datas);
    }
  }})
}

/**
 * 根据内部APi 获取相应数据
 * @param innerApiList
 * @param dataSourceList
 */
export function loadByInnerApiList(innerApiList:any, dataSourceList:any) {
  //内部api
  innerApiList&&innerApiList.forEach((innerApiRecord: any) => {
    if (innerApiRecord == null || innerApiRecord === "") {
      return
    }
    try {
      getDatasByInnerApi(innerApiRecord, (datas) => {
        if (datas && datas.records) {
          dataSourceList[innerApiRecord.id] = {records:datas.records,total:datas.total};
        }
      });
    } catch (e) {

    }
  })
}


/**
 *  获取连接器数据
 * @param innerApiList
 * @param dataSourceList
 */
export function loadByConnectionApiList(connectionList:any, dataSourceList:any) {
  //集成服务Api
  connectionList&&connectionList.forEach((connectionApiRecord:any)=>{
    if(connectionApiRecord==null||connectionApiRecord===""){
      return
    }
    try{
      getDatasByConnectionApi({connectionApiRecord,successFun:(datas)=>{
        if(datas&&datas.records){
          dataSourceList[connectionApiRecord.id]={records:datas.records,total:datas.total};
        }else{
          if(datas.total==null){
            datas.total=datas.length;
          }
          dataSourceList[connectionApiRecord.id]={records:datas,total:datas.total};
        }
      },curPage:1,pageSize:connectionApiRecord.pageSize||GoingNewUtils.pageSizeNumber});
    }catch (e){

    }
  })
}
